// images
import iconTel from "../images/common/icon/fixed-btn/tel_white.webp";
import iconKakao from "../images/common/icon/fixed-btn/kakao_white.webp";
import iconYoutube from "../images/common/icon/fixed-btn/youtube_white.webp";
import iconContact from "../images/common/icon/fixed-btn/contact_white.webp";
import iconBlog from "../images/common/icon/fixed-btn/blog_white.webp";
import { useEffect } from "react";

const FixedBtn = () => {
    const btnItems = [
        {
            isOnlyPc: true,
            modal: {
                icon: "xi-call",
                label: "031-234-2870",
            },
            link: { path: "tel:031-234-2870", target: "_self" },
            icon: iconTel,
            label: "전화문의",
        },
        {
            link: { path: "https://pf.kakao.com/_DnVQG", target: "_blank" },
            icon: iconKakao,
            label: "카톡문의",
        },
        {
            link: {
                path: "https://www.youtube.com/@%EC%9A%B0%EC%88%98%EC%A1%B0%EB%8B%AC%EC%BB%A8%EC%84%A4%ED%8C%85",
                target: "_blank",
            },
            icon: iconYoutube,
            label: "유튜브",
        },
        {
            link: {
                path: "/customer/contact",
                target: "_self",
            },
            icon: iconContact,
            label: "문의하기",
        },
        {
            link: {
                path: "https://blog.naver.com/rhim1218",
                target: "_blank",
            },
            icon: iconBlog,
            label: "블로그",
        },
    ];

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        const topScrollBtn = document.querySelector(".btn-scroll-top");

        if (topScrollBtn) {
            topScrollBtn.addEventListener("click", function () {
                window.scrollTo({ top: 0, behavior: "smooth" });
            });

            document.addEventListener("scroll", function () {
                if (document.documentElement.scrollTop > 88) {
                    topScrollBtn.classList.add("active");
                } else {
                    topScrollBtn.classList.remove("active");
                }

                const scrollPercent =
                    (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
                const color = getColorFromPercentage(scrollPercent);

                const progressBar = topScrollBtn.querySelector(".progress-bar") as HTMLElement;
                if (progressBar) {
                    progressBar.style.background = `conic-gradient(${color} 0% ${scrollPercent}%, #fff ${scrollPercent}% 100%)`;
                }
            });
        }

        function getColorFromPercentage(percentage: number) {
            const startColor = [255, 255, 255]; // RGB 값으로 작성해야함!
            const endColor = [32, 32, 32];

            const color = startColor.map((start, i) => {
                return Math.round(start + (endColor[i] - start) * (percentage / 100));
            });

            return `rgb(${color.join(",")})`;
        }
    }, []);

    return (
        <div className="fixed md:w-auto w-full bottom-0 md:bottom-40 right-0 z-[9970] rounded-xl shadow">
            {/* 모바일 탑버튼 */}
            <button className="btn-scroll-top md:hidden shadow-md block ml-auto mr-16 mb-32 bg-white size-40 flex-center rounded-full">
                <i className="xi-arrow-up relative z-10 text-[#202020]"></i>
                <div className="progress-bar"></div>
            </button>

            {/* 바로가기 버튼 */}
            <ul className="md:flex grid grid-cols-4 rotate-180 md:rotate-0 md:flex-col bg-[#302d2c] md:rounded-[8px_0px_0px_0px]">
                {btnItems.map((btnItem, index) => (
                    <li
                        key={index}
                        className={`${btnItem.isOnlyPc && "hidden md:block"} group relative md:rotate-0 rotate-180 md:border-none md:border-0 border-r first:border-r-0 border-white/50`}
                    >
                        <a
                            href={btnItem.link.path}
                            target={btnItem.link.target}
                            className="h-80 md:w-120 w-full flex-col flex-center gap-8"
                        >
                            <img className="w-auto h-26 xl:h-32" src={btnItem.icon} alt={btnItem.label} />
                            <span className="text-white text-sm">{btnItem.label}</span>
                        </a>

                        {/* 관련 모달이 있을 때 */}
                        {btnItem.modal && (
                            <div className="group-hover:flex hidden absolute text-sm top-1/2 -translate-y-1/2 w-max translate-x-[-100%] text-white bg-[#e95e02] rounded-full py-10 px-16 gap-8 -left-10 items-center">
                                <i className={btnItem.modal.icon}></i>
                                <span>{btnItem.modal.label}</span>
                            </div>
                        )}
                    </li>
                ))}
            </ul>

            {/* pc 탑버튼 */}
            <button
                onClick={scrollToTop}
                className="w-full md:block hidden md:rounded-[0px_0px_0px_8px] py-8 text-[#202020] font-bold bg-white text-xl"
            >
                TOP
            </button>
        </div>
    );
};

export default FixedBtn;
